/* B2B header behavior:
   - Department mega menus open on hover after 120ms, stay open while the cursor
     moves into the panel, close on leave (150ms grace), Esc, or outside click.
   - All Departments panel: left column switches right pane; same close rules.
   Vanilla JS, no dependencies. */

(function () {
  var bar = document.querySelector('.department-bar');
  var HOVER_OPEN_MS = bar ? parseInt(bar.dataset.hoverDelay, 10) || 120 : 120;
  var HOVER_CLOSE_MS = 150;
  var OPEN_ON_CLICK = bar ? bar.dataset.openOn === 'click' : false;

  function syncAria(details) {
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', details.hasAttribute('open') ? 'true' : 'false');
  }

  function closeAll(except) {
    document.querySelectorAll('.department-bar details[open]').forEach(function (details) {
      if (details !== except) {
        details.removeAttribute('open');
        syncAria(details);
      }
    });
  }

  document.querySelectorAll('.department-bar details').forEach(function (details) {
    var openTimer = null;
    var closeTimer = null;

    if (OPEN_ON_CLICK) return; // click mode: native details toggle only

    details.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      openTimer = setTimeout(function () {
        closeAll(details);
        details.setAttribute('open', '');
        syncAria(details);
      }, HOVER_OPEN_MS);
    });

    details.addEventListener('mouseleave', function () {
      clearTimeout(openTimer);
      closeTimer = setTimeout(function () {
        details.removeAttribute('open');
        syncAria(details);
      }, HOVER_CLOSE_MS);
    });

    details.addEventListener('toggle', function () {
      syncAria(details);
      if (details.hasAttribute('open')) closeAll(details);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll(null);
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-sticky-all-depts]')) return; // ghost button manages the panel itself
    if (!event.target.closest('.department-bar')) closeAll(null);
  });

  /* All Departments: left-column buttons switch the visible pane. */
  document.querySelectorAll('.all-departments__dept').forEach(function (button) {
    function activate() {
      var panel = button.closest('.all-departments__panel');
      if (!panel) return;
      panel.querySelectorAll('.all-departments__dept').forEach(function (other) {
        other.classList.toggle('is-active', other === button);
        other.setAttribute('aria-expanded', other === button ? 'true' : 'false');
      });
      panel.querySelectorAll('.all-departments__pane').forEach(function (pane) {
        pane.classList.toggle('is-active', pane.id === button.dataset.deptTarget);
      });
    }
    button.addEventListener('click', activate);
    button.addEventListener('mouseenter', activate);
  });
})();

/* Exact part-number match: Enter with no highlighted option goes straight to
   the PDP when the dropdown shows a "Part number match" row. */
(function () {
  document.querySelectorAll('predictive-search input[type="search"]').forEach(function (input) {
    input.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      if (input.getAttribute('aria-activedescendant')) return; // an option is highlighted
      var exact = document.querySelector('[data-exact-match] a');
      if (exact && exact.offsetParent !== null) {
        event.preventDefault();
        event.stopPropagation();
        window.location.href = exact.getAttribute('href');
      }
    });
  });
})();

/* "Added to cart" toast on mobile after any AJAX add (Dawn pubsub). */
(function () {
  if (typeof subscribe !== 'function') return;
  var toast;
  function showToast() {
    if (window.innerWidth >= 750) return;
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cart-toast';
      toast.setAttribute('role', 'status');
      toast.textContent = 'Added to cart';
      document.body.appendChild(toast);
    }
    toast.classList.add('cart-toast--visible');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () {
      toast.classList.remove('cart-toast--visible');
    }, 2400);
  }
  subscribe('cart-update', function (data) {
    if (data && data.source === 'product-form') showToast();
  });
})();

/* Delivery ZIP handling moved to assets/delivery.js (DeliveryZip module). */

/* Search scope + recent searches + default (empty-focus) panel */
(function () {
  var RECENT_KEY = 'recent-searches';
  function recents() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { return []; }
  }
  function remember(term) {
    if (!term) return;
    var list = recents().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
    list.unshift(term);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 5))); } catch (e) {}
  }

  document.querySelectorAll('.header-search-inline').forEach(function (root) {
    var form = root.querySelector('form.search');
    var input = root.querySelector('input[type="search"]');
    var scope = root.querySelector('[data-search-scope]');
    var panel = root.querySelector('[data-search-default]');
    if (!form || !input) return;

    form.addEventListener('submit', function (event) {
      var term = input.value.trim();
      remember(term);
      var mode = scope ? scope.value : 'all';
      if (!term) return;
      var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (mode === 'brand') {
        event.preventDefault();
        window.location.href = routeRoot + 'collections/' + term.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      } else if (mode === 'part') {
        // Try an exact variant SKU/barcode jump first; fall back to normal search.
        event.preventDefault();
        fetch(
          (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') +
            'search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=3'
        )
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var products = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (products.length === 1) {
              window.location.href = products[0].url.split('?')[0];
            } else {
              window.location.href = routeRoot + 'search?q=' + encodeURIComponent(term);
            }
          })
          .catch(function () { window.location.href = routeRoot + 'search?q=' + encodeURIComponent(term); });
      }
    });

    if (!panel) return;
    function renderRecents() {
      var wrap = panel.querySelector('[data-recent-searches]');
      var list = panel.querySelector('[data-recent-searches-list]');
      var terms = panel.hasAttribute('data-no-recents') ? [] : recents();
      if (!wrap || !list || !terms.length) { if (wrap) wrap.hidden = true; return; }
      wrap.hidden = false;
      list.innerHTML = '';
      terms.forEach(function (term) {
        var li = document.createElement('li');
        li.className = 'search-recent-row';

        var a = document.createElement('a');
        a.className = 'search-recent-row__link link';
        a.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'search?q=' + encodeURIComponent(term);
        a.innerHTML =
          '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>';
        a.appendChild(document.createTextNode(term));

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'search-recent-row__remove';
        remove.setAttribute('aria-label', 'Remove "' + term + '" from recent searches');
        remove.textContent = '×';
        remove.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var kept = recents().filter(function (t) { return t !== term; });
          try { localStorage.setItem(RECENT_KEY, JSON.stringify(kept)); } catch (err) {}
          renderRecents();
        });

        li.appendChild(a);
        li.appendChild(remove);
        list.appendChild(li);
      });
    }
    function maybeShow() {
      if (input.value.trim() === '') {
        renderRecents();
        panel.hidden = false;
      } else {
        panel.hidden = true;
      }
    }
    input.addEventListener('focus', maybeShow);
    input.addEventListener('input', maybeShow);
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.header-search-inline')) panel.hidden = true;
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) {
        panel.hidden = true;
        input.focus();
      }
    });
  });
})();

/* Promo strip: show unless this message was dismissed before */
(function () {
  document.querySelectorAll('[data-promo-strip]').forEach(function (strip) {
    if (strip.hasAttribute('data-promo-permanent')) return; // not dismissible
    var key = 'promo-dismissed-' + (strip.dataset.promoKey || '');
    try { if (localStorage.getItem(key)) return; } catch (e) {}
    strip.hidden = false;
    var dismiss = strip.querySelector('[data-promo-dismiss]');
    if (dismiss) {
      dismiss.addEventListener('click', function () {
        strip.hidden = true;
        try { localStorage.setItem(key, '1'); } catch (e) {}
      });
    }
  });
})();

/* Custom search scope selector (replaces native select): listbox pattern with
   arrow keys / Enter / Esc, check icon on active option, placeholder swap. */
class ScopeSelect extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.search-scope__button');
    this.menu = this.querySelector('.search-scope__menu');
    // The .field wrapper clips (overflow:hidden for its rounded corners), so the
    // menu must live outside it; keep it inside .header-search-inline for positioning.
    this.searchRoot = this.closest('.header-search-inline');
    if (this.menu && this.searchRoot && this.menu.parentElement !== this.searchRoot) {
      this.searchRoot.appendChild(this.menu);
    }
    this.label = this.querySelector('[data-scope-label]');
    this.hiddenInput = this.querySelector('[data-search-scope]');
    this.options = Array.from(this.querySelectorAll('[role="option"]'));
    this.searchInput = this.closest('.field')?.querySelector('input[type="search"]');

    if (!this.bound) {
      // Child listeners are GC'd with the element; only bind them once per node.
      this.bound = true;
      this.button.addEventListener('click', () => this.toggle(this.menu.hidden));
      this.button.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          this.toggle(true);
          this.focusOption(0);
        }
      });
      this.options.forEach((option, index) => {
        option.addEventListener('click', () => this.select(option));
        option.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown') { e.preventDefault(); this.focusOption(index + 1); }
          else if (e.key === 'ArrowUp') { e.preventDefault(); this.focusOption(index - 1); }
          else if (e.key === 'Home') { e.preventDefault(); this.focusOption(0); }
          else if (e.key === 'End') { e.preventDefault(); this.focusOption(this.options.length - 1); }
          else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.select(option); }
          else if (e.key === 'Escape') { this.toggle(false); this.button.focus(); }
        });
      });
      var ownsNode = (node) => this.contains(node) || this.menu.contains(node);
      this.ownsNode = ownsNode;
      this.addEventListener('focusout', (e) => {
        if (!this.menu.hidden && e.relatedTarget && !ownsNode(e.relatedTarget)) this.toggle(false);
      });
      this.menu.addEventListener('focusout', (e) => {
        if (!this.menu.hidden && e.relatedTarget && !ownsNode(e.relatedTarget)) this.toggle(false);
      });
    }

    // Document-level listeners: bound handlers, removed on disconnect.
    this.onDocClick = this.onDocClick || ((e) => {
      if (!this.menu.hidden && !this.ownsNode(e.target)) this.toggle(false);
    });
    this.onDocKeydown = this.onDocKeydown || ((e) => {
      if (e.key === 'Escape' && !this.menu.hidden) this.toggle(false);
    });
    document.addEventListener('click', this.onDocClick);
    document.addEventListener('keydown', this.onDocKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocClick);
    document.removeEventListener('keydown', this.onDocKeydown);
  }

  toggle(open) {
    this.menu.hidden = !open;
    this.button.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  focusOption(index) {
    var clamped = Math.max(0, Math.min(this.options.length - 1, index));
    this.options[clamped].focus();
  }

  select(option) {
    this.options.forEach((o) => o.setAttribute('aria-selected', o === option ? 'true' : 'false'));
    this.label.textContent = option.dataset.label;
    this.hiddenInput.value = option.dataset.value;
    if (this.searchInput && option.dataset.placeholder) {
      this.searchInput.setAttribute('placeholder', option.dataset.placeholder);
    }
    this.toggle(false);
    this.button.focus();
  }
}

if (!customElements.get('scope-select')) {
  customElements.define('scope-select', ScopeSelect);
}

/* Sticky "All Departments" ghost button: opens the same full-tree panel that
   lives in the (hidden-when-sticky) department bar. */
(function () {
  var button = document.querySelector('[data-sticky-all-depts]');
  var panel = document.getElementById('AllDepartmentsPanel');
  if (!button || !panel || button.dataset.bound) return;
  button.dataset.bound = '1'; // theme-editor re-render guard
  // Single source of truth: the details' toggle event keeps BOTH triggers'
  // aria-expanded in sync no matter which code path opened/closed the panel.
  panel.addEventListener('toggle', function () {
    var open = panel.hasAttribute('open');
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    var summary = panel.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  button.addEventListener('click', function () {
    var willOpen = !panel.hasAttribute('open');
    if (willOpen) {
      panel.setAttribute('open', '');
      var firstDept = panel.querySelector('.all-departments__dept');
      if (firstDept) firstDept.focus();
    } else {
      panel.removeAttribute('open');
      button.focus();
    }
  });
  panel.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.hasAttribute('open')) {
      panel.removeAttribute('open');
      button.focus();
    }
  });
})();

/* Elite sticky extras: contextual compact placeholder, MPN copy chip,
   mobile compact search toggle. */
(function () {
  var sectionHeader = document.querySelector('.section-header');
  if (!sectionHeader) return;

  /* Contextual placeholder on collection pages while compact */
  var slot = document.querySelector('.header-search-slot[data-context-placeholder]');
  if (slot) {
    var input = slot.querySelector('input[type="search"]');
    var normalPlaceholder = input ? input.getAttribute('placeholder') : '';
    var applyContext = function () {
      if (!input) return;
      var compact = sectionHeader.classList.contains('is-compact');
      input.setAttribute('placeholder', compact ? slot.dataset.contextPlaceholder : normalPlaceholder);
    };
    new MutationObserver(applyContext).observe(sectionHeader, { attributes: true, attributeFilter: ['class'] });
    applyContext();
  }

  /* MPN quick-copy chip (product pages) */
  var chip = document.querySelector('[data-copy-mpn]');
  if (chip && !chip.dataset.bound) {
    chip.dataset.bound = '1';
    chip.addEventListener('click', function () {
      var value = chip.dataset.copyMpn;
      var done = function (message) {
        var toast = document.querySelector('.cart-toast');
        if (!toast) {
          toast = document.createElement('div');
          toast.className = 'cart-toast';
          toast.setAttribute('role', 'status');
          document.body.appendChild(toast);
        }
        toast.textContent = message;
        toast.classList.add('cart-toast--visible');
        clearTimeout(toast._timer);
        toast._timer = setTimeout(function () { toast.classList.remove('cart-toast--visible'); }, 1600);
      };
      var fail = function () { done('Copy failed'); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(value).then(function () { done('Copied'); }, fail);
      } else {
        fail();
      }
    });
  }

  /* Mobile compact: search icon expands the row */
  var toggle = document.querySelector('[data-mobile-search-toggle]');
  var row = document.getElementById('MobileSearchRow');
  if (toggle && row && !toggle.dataset.bound) {
    toggle.dataset.bound = '1';
    toggle.addEventListener('click', function () {
      var open = document.body.classList.toggle('mobile-search-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var searchInput = row.querySelector('input[type="search"]');
        if (searchInput) searchInput.focus();
      }
    });
  }
})();

/* Product chip: shows the MPN (or the selected variant's SKU once a variant is chosen),
   never widens the header: CSS ellipsis + at 1200-1439px values longer than 14 chars show
   an ellipsis and the last 10 chars (the distinguishing suffix). Full value stays in the
   title/aria-label and is what gets copied. */
(function () {
  var chip = document.querySelector('.header-mpn-chip');
  if (!chip || chip.dataset.chipBound) return;
  chip.dataset.chipBound = '1';
  var valueEl = chip.querySelector('[data-chip-value]');
  var mid = window.matchMedia('(min-width: 1200px) and (max-width: 1439px)');
  var full = chip.getAttribute('data-copy-mpn') || (valueEl ? valueEl.textContent.trim() : '');
  var render = function () {
    if (!valueEl) return;
    var shown = full;
    if (mid.matches && full.length > 14) shown = '\u2026' + full.slice(-10);
    valueEl.textContent = shown;
    valueEl.setAttribute('data-chip-value', full);
    chip.setAttribute('data-copy-mpn', full);
    chip.setAttribute('title', (chip.getAttribute('data-copy-label') || 'Copy') + ' ' + full);
    chip.setAttribute('aria-label', (chip.getAttribute('data-copy-label') || 'Copy') + ' ' + full);
  };
  var setValue = function (v) { if (v) { full = String(v); render(); } };
  render();
  mid.addEventListener('change', render);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
      var v = e && e.data && e.data.variant;
      if (v && v.sku) setValue(v.sku);
    });
  }
  // self-updating via PUB_SUB_EVENTS.variantChange above; no external hook needed
})();
